import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { DataColumn } from "../../controls/Data.default";
import {
  buildSearchQuery,
  dateRangeValue,
  QueryFieldMapping,
} from "../../code/search-query/query-mapper";
import { Dayjs } from "dayjs";

export interface AssessmentReportsForm {
  readonly name: string;
  readonly createdByUserUserName: string;
  readonly createdOn: Dayjs[];
}

export const assessmentReportsViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 220,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Short description",
    key: "shortDescription",
    width: 240,
    sort: true,
  },
  {
    title: "Type",
    key: "kind",
    width: 100,
    sort: true,
    type: "badge",
  },
  {
    // Base → "N KPIs"; Meta → "<operator> · N input(s)" so a computed report shows what it's comprised of.
    // Keyed on kpiCount (always a non-null number) so the Data grid actually runs the transform — it skips
    // transform when the cell's own field value is null.
    title: "Composition",
    key: "kpiCount",
    width: 220,
    sort: false,
    transform: (_value: any, record: any) =>
      record?.kind === "Meta"
        ? `${record.compositeOperator ?? "—"} · ${record.componentCount} input(s)`
        : `${record?.kpiCount ?? 0} KPIs`,
  },
  {
    title: "Created by",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Created on",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const assessmentReportsQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.Contains },
  { formField: "createdByUserUserName", operation: QueryOperation.Contains },
  { formField: "createdOn", operation: QueryOperation.Between, transform: dateRangeValue },
];

export const mapAssessmentReportsViewQuery = (
  values: AssessmentReportsForm,
): SearchQuery => buildSearchQuery(values, assessmentReportsQueryMappings);
